import _ from 'lodash';
import { get } from './agent';

const productUpdates =
  (workspacesUrl) =>
  (id = '') => {
    const url = _([workspacesUrl, 'product-updates', id]).compact().join('/');

    return {
      get: () => get(url),
    };
  };

export default productUpdates;
